// eslint-disable-next-line import/prefer-default-export
export default {
  tracker: "/api/industrial/tracking",
  manufacturers: "/api/industrial/manufacturer",
  products: "/api/industrial/products",
  types: "/api/industrial/type",
  group: "/api/industrial/group",
};
